import OrderDTO from "@/dto/order/OrderDTO";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { deleteWaybillNo } from "@/services/api/order";
import { ordersGroupByShopId } from "@/utils/OrderUtils";
import { useRequest } from "ahooks";
import { message } from "antd";

export default function useDeleteWaybillNoClick(getSelectedOrders: () => OrderDTO[]) {
    const orderManagementStore = useOrderManagementStore();

    return useRequest(
        async () => {
            const selectedOrders = getSelectedOrders();

            if (!selectedOrders?.length) {
                return;
            }

            const ordersChunk = ordersGroupByShopId(selectedOrders);

            for (let i = 0; i < ordersChunk.length; i++) {
                const partOrders = ordersChunk[i];

                const selectedOrderIds = partOrders.map((order) => order.id);

                await deleteWaybillNo(partOrders);

                const newProps: Partial<OrderDTO> = { waybillNo: "", hasEwaybillNo: false, ewaybills: [] };

                orderManagementStore.table.updateOrders(selectedOrderIds, newProps);
            }

            message.success("删除运单号成功");
        },
        {
            manual: true,
        },
    );
}
